{
    "coordinates": [
        29.79790602833107,
        29.04546079527472
    ],
    "tooltip": "Jebel Qatrani",
    "title": "Jebel Qatrani",
    "country": "Egypt",
    "period": "Paleogene",
    "alt": "TODO"
}
